module.exports = __webpack_public_path__ + "img/confirmed.b9449d7a.png";